<div class="rndc-page">

  <!-- Header -->
  <div class="rndc-header">
    <div class="rndc-header__title">
      <span class="live-dot"></span>
      <h2>Estado canales RNDC</h2>
    </div>
    <span class="rndc-header__sub">Monitoreo en tiempo real · actualización automática</span>
  </div>

  <!-- Channel cards -->
  <div class="channels-grid">
    <div *ngFor="let ch of channels"
         class="channel-card"
         [ngClass]="ch.isUp ? 'channel-card--up' : 'channel-card--down'">

      <div class="channel-card__status-bar"></div>

      <div class="channel-card__body">
        <div class="channel-card__icon">
          <i class="fas" [ngClass]="ch.isUp ? 'fa-check-circle' : 'fa-times-circle'"></i>
        </div>
        <div class="channel-card__info">
          <span class="channel-card__name">{{ ch.label }}</span>
          <span class="channel-card__time" *ngIf="ch.lastChecked">
            Verificado {{ ch.lastChecked | date:'dd/MM/yyyy HH:mm' }}
          </span>
          <span class="channel-card__time channel-card__time--empty" *ngIf="!ch.lastChecked">
            Sin datos aún
          </span>
        </div>
        <div class="channel-card__badge" [ngClass]="ch.isUp ? 'badge--up' : 'badge--down'">
          {{ ch.isUp ? 'Activo' : 'Caído' }}
        </div>
      </div>

      <div class="channel-card__processes">
        <span *ngFor="let p of ch.processes" class="process-tag">{{ p }}</span>
      </div>

    </div>
  </div>

  <!-- History -->
  <div class="history-section">
    <div class="history-section__header">
      <div>
        <h4 class="history-section__title">Historial de estados</h4>
        <span class="history-section__sub">Últimos registros por canal</span>
      </div>
      <button type="button" mat-icon-button (click)="loadHistory()" [disabled]="loadingHistory"
              class="history-btn" matTooltip="Refrescar historial" title="Refrescar historial">
        <i class="fas" [ngClass]="loadingHistory ? 'fa-spinner fa-spin' : 'fa-sync-alt'"></i>
      </button>
    </div>

    <!-- Empty -->
    <div *ngIf="!loadingHistory && history.length === 0" class="history-empty">
      <i class="fas fa-inbox"></i>
      <p>Sin registros en el historial</p>
    </div>

    <!-- Table -->
    <div *ngIf="history.length > 0" class="history-table">
      <div class="history-table__head">
        <span class="col-fecha">Fecha</span>
        <span class="col-canal">Canal A · WS1</span>
        <span class="col-canal">Canal B · WS2</span>
        <span class="col-canal">Canal C · PLC</span>
      </div>
      <div *ngFor="let record of history; let odd = odd"
           class="history-table__row"
           [ngClass]="{'history-table__row--odd': odd}">
        <span class="col-fecha col-fecha--val">{{ record.date | dateFormat:'col-date' }}</span>
        <span class="col-canal">
          <span class="status-dot" [ngClass]="record.stateChannel1 ? 'status-dot--up' : 'status-dot--down'"
                [matTooltip]="record.stateChannel1 ? 'Activo' : 'Caído'"></span>
        </span>
        <span class="col-canal">
          <span class="status-dot" [ngClass]="record.stateChannel2 ? 'status-dot--up' : 'status-dot--down'"
                [matTooltip]="record.stateChannel2 ? 'Activo' : 'Caído'"></span>
        </span>
        <span class="col-canal">
          <span class="status-dot" [ngClass]="record.stateChannelPLC ? 'status-dot--up' : 'status-dot--down'"
                [matTooltip]="record.stateChannelPLC ? 'Activo' : 'Caído'"></span>
        </span>
      </div>
    </div>

  </div>

</div>
